<div *ngIf="isMobile">
  <app-summary-mobile projectType="lead" [quote]="lead" (updated)="leadUpdated($event)"></app-summary-mobile>
</div>
<div *ngIf="!isMobile">
  <app-summary-desktop projectType="lead" [quote]="lead" (updated)="leadUpdated($event)"></app-summary-desktop>
</div>
